<template>
  <v-image :image="image" :contain="true" :caption="caption"/>
</template>

<script>
  import VImage from './Image.vue';

  export default {
    components: {
      VImage
    },
    props: {
      image: Object,
      caption: String
    }
  }
</script>

<style lang="scss" scoped>
</style>
